import { render, staticRenderFns } from "./ProjectCoach.vue?vue&type=template&id=66840099&scoped=true&"
import script from "./ProjectCoach.vue?vue&type=script&lang=js&"
export * from "./ProjectCoach.vue?vue&type=script&lang=js&"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=66840099&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66840099",
  null
  
)

export default component.exports